export default __webpack_public_path__ + "static/media/world-map.02b0b4b8.svg";